import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'

export const SignUpServices = {
    SignUp,
    changePassword,
    sendOtp,
    validate,
    emailAndNumberVerification,
    emailAndNumberVerificationByToken
}

async function SignUp(data) {
    try {
        const response = await RestMethod.POST('/users/signup', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function changePassword(data) {
    try {
        const response = await RestMethod.POST('/users/self/change-password', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function sendOtp(phone){
    try {
        const response = await RestMethod.POST('/users/send-otp', phone);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function validate(data){
    try {
        const response = await RestMethod.POST('/users/validate-otp', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function emailAndNumberVerification(data){
    try {
        const response = await RestMethod.POST('/users/verify-emiail-number', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return false;
    }
}

async function emailAndNumberVerificationByToken(id){
    try {
        const response = await RestMethod.GET('/users/validate-email/'+id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}